import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedGmailApp from "./EmbeddedGmailApp";
const ExternalLink = ({ href, children }) => /* @__PURE__ */ React.createElement("a", { href, rel: "noopener noreferrer", target: "_blank" }, children);
const GmailApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("gmail.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("gmail.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "gmail.app.requirements",
      components: {
        workspaceLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://workspace.google.com/" }),
        cloudLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://console.cloud.google.com/" })
      }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedGmailApp, null));
};
export default GmailApp;
